/**
 * Function to check if a selector returns any elements and return if not.
 * @param {element} div - The div element where the selector should find its result.
 * @param {string} selector - CSS selector to check if it returns any elements.
 */
export function noSelectorReturn(div, selector) {
	if (!div || !div.selector || !div.querySelectorAll(selector).length) {
		return;
	}
}
